import { withInstall } from '@bigin/utils'

import Input from './src/input.vue'

export const BInput = withInstall(Input)
export default BInput

export * from './src/input'
